import { useMemo, useState } from "react";
import { Form } from "antd";
import { ReusableModal } from "@/components/UI/Modals/CustomModals";
import { message, Select } from "antd";
// import { ReusableModal } from "@/components/UI/Modals/CustomModals";
import AddPackageModal from "./AddPackage";
import { useGetAllCustomersQuery } from "@/services/api/user/customerApi";
import { useGetLocationsQuery } from "@/services/api/location/locationApi";
// import dayjs from "dayjs";
import DeliverySection from "../../component/deliverySection";
import CustomOrderForm from "../sections/CustomOrderForm";
import { useGetServiceFeesQuery } from "@/services/api/serviceFee/serviceFeeApi";
import CustomOrderReviewStep from "../sections/CustomOrderReviewStep";
import CateringPackageReviewStep from "../sections/CateringPackageReviewStep";
import CateringPackageSelect from "../sections/CateringPackageSelect";
import { useGetEventTypeQuery } from "@/services/api/event/eventTypeApi";
import { useGetDietaryPreferencesQuery } from "@/services/api/event/dietarypreferencesApi";
import { useGetPackageTypeQuery } from "@/services/api/event/packageTypeApi";
import { useGetBeverageTypeQuery } from "@/services/api/event/beverageTypeApi";
import { useGetServiceTypeQuery } from "@/services/api/event/serviceTypeApi";
import {
  useCreateEventCustomOrderMutation,
  useCreateEventPackageOrderMutation,
} from "@/services/api/orders/ordersApi";

const CreateEventOrderModal = ({ open, onClose }) => {
  const { data: customersResponse, isLoading: customerLoading } =
    useGetAllCustomersQuery(undefined, { skip: !open });
  const { data: locations = [], isLoading: locationLoading } =
    useGetLocationsQuery(undefined, { skip: !open });
  const { data: serviceFees } = useGetServiceFeesQuery();
  const { data: eventTypesResponse, isLoading: eventTypesLoading } =
    useGetEventTypeQuery();
  const { data: dietaryPrefsResponse, isLoading: dietaryPrefsLoading } =
    useGetDietaryPreferencesQuery();
  const { data: beverageTypesResponse, isLoading: beverageTypesLoading } =
    useGetBeverageTypeQuery();
  const { data: packageTypesResponse, isLoading: packageTypesLoading } =
    useGetPackageTypeQuery();
  const { data: serviceTypesResponse, isLoading: serviceTypesLoading } =
    useGetServiceTypeQuery();
  const [createEventCustomOrder, { isLoading: creatingCustomOrder }] =
    useCreateEventCustomOrderMutation();
  const [createEventPackageOrder, { isLoading: creatingPackageOrder }] =
    useCreateEventPackageOrderMutation();

  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [packageType, setPackageType] = useState("");
  const [addPackageModalOpen, setAddPackageModalOpen] = useState(false);
  const [cateringPackages, setCateringPackages] = useState([]);
  const [discount, setDiscount] = useState("");
  const [deliveryType, setDeliveryType] = useState("delivery");
  const [discountType, setDiscountType] = useState("percentage");

  // Transform API responses to select options
  const eventTypeOptions = useMemo(() => {
    const data = eventTypesResponse?.data || eventTypesResponse || [];
    return Array.isArray(data)
      ? data.map((item) => ({
          value: item.id,
          label: item.name || item.label || item.type,
        }))
      : [];
  }, [eventTypesResponse]);

  const dietaryPreferenceOptions = useMemo(() => {
    const data = dietaryPrefsResponse?.data || dietaryPrefsResponse || [];
    return Array.isArray(data)
      ? data.map((item) => ({
          value: item.id,
          label: item.name || item.label || item.preference,
        }))
      : [];
  }, [dietaryPrefsResponse]);

  const beverageTypeOptions = useMemo(() => {
    const data = beverageTypesResponse?.data || beverageTypesResponse || [];
    return Array.isArray(data)
      ? data.map((item) => ({
          value: item.id,
          label: item.name || item.label || item.type,
        }))
      : [];
  }, [beverageTypesResponse]);

  const customPackageTypeOptions = useMemo(() => {
    const data = packageTypesResponse?.data || packageTypesResponse || [];
    return Array.isArray(data)
      ? data.map((item) => ({
          value: item.id,
          label: item.name || item.label || item.type,
        }))
      : [];
  }, [packageTypesResponse]);

  const serviceTypeOptions = useMemo(() => {
    const data = serviceTypesResponse?.data || serviceTypesResponse || [];
    return Array.isArray(data)
      ? data.map((item) => ({
          value: item.id,
          label: item.name || item.label || item.type,
        }))
      : [];
  }, [serviceTypesResponse]);

  // Transform location data for branch dropdown
  const locationOptions = useMemo(
    () =>
      locations.map((loc) => ({
        value: loc.id,
        label: `${loc.name} - ${loc.state?.name || ""}`,
      })),
    [locations]
  );

  const customerOptions = useMemo(() => {
    if (!customersResponse?.data) return [];
    return customersResponse.data.map((customer) => ({
      value: customer.id,
      label: `${customer.first_name || ""} ${customer.last_name || ""}`.trim(),
    }));
  }, [customersResponse]);

  const packageTypeOptions = [
    { value: "package", label: "Catering Package" },
    { value: "custom", label: "Custom Order" },
  ];

  const handlePackageTypeChange = (value) => {
    setPackageType(value);
  };

  const getCustomerLabel = () => {
    const customerValue = form.getFieldValue("customer");
    const customer = customerOptions.find(
      (c) => c.value === parseInt(customerValue)
    );
    return customer?.label || "Not selected";
  };
  const getEventTypeLabel = () => {
    const eventTypeValue = form.getFieldValue("eventType");
    const eventType = eventTypeOptions.find(
      (e) => e.value === parseInt(eventTypeValue)
    );
    return eventType?.label || "Not selected";
  };
  const getServiceTypeLabel = () => {
    const serviceTypeValue = form.getFieldValue("serviceType");
    const serviceType = serviceTypeOptions.find(
      (s) => s.value === parseInt(serviceTypeValue)
    );
    return serviceType?.label || "Not selected";
  };
  const getDietaryPreferenceLabel = () => {
    const dietaryPreferenceValue = form.getFieldValue("dietaryRequirements");
    if (
      !dietaryPreferenceValue ||
      (Array.isArray(dietaryPreferenceValue) &&
        dietaryPreferenceValue.length === 0)
    ) {
      return "N/A"; // Or "Not selected"
    }

    // If it's an array of IDs
    if (Array.isArray(dietaryPreferenceValue)) {
      const selectedLabels = dietaryPreferenceValue
        .map((id) => {
          // Ensure id is a number if your options use numbers
          const numericId = typeof id === "string" ? parseInt(id, 10) : id;
          const dietaryPreferenceType = dietaryPreferenceOptions.find(
            (b) => b.value === numericId
          );
          return dietaryPreferenceType?.label; // Return label or undefined if not found
        })
        .filter(Boolean); // Filter out any undefined labels (for IDs not found)

      return selectedLabels.length > 0 ? selectedLabels.join(", ") : "N/A";
    }
  };
  const getbeverageTypeLabel = () => {
    const beverageTypeValue = form.getFieldValue("drinks");

    // Handle cases where no value is selected
    if (
      !beverageTypeValue ||
      (Array.isArray(beverageTypeValue) && beverageTypeValue.length === 0)
    ) {
      return "N/A"; // Or "Not selected"
    }

    // If it's an array of IDs
    if (Array.isArray(beverageTypeValue)) {
      const selectedLabels = beverageTypeValue
        .map((id) => {
          // Ensure id is a number if your options use numbers
          const numericId = typeof id === "string" ? parseInt(id, 10) : id;
          const beverageType = beverageTypeOptions.find(
            (b) => b.value === numericId
          );
          return beverageType?.label; // Return label or undefined if not found
        })
        .filter(Boolean); // Filter out any undefined labels (for IDs not found)

      return selectedLabels.length > 0 ? selectedLabels.join(", ") : "N/A";
    }
  };
  const getpackageTypeLabel = () => {
    const packageTypeValue = form.getFieldValue("packageType");

    // Handle cases where no value is selected
    if (
      !packageTypeValue ||
      (Array.isArray(packageTypeValue) && packageTypeValue.length === 0)
    ) {
      return "N/A"; // Or "Not selected"
    }

    // If it's an array of IDs
    if (Array.isArray(packageTypeValue)) {
      const selectedLabels = packageTypeValue
        .map((id) => {
          // Ensure id is a number if your options use numbers
          const numericId = typeof id === "string" ? parseInt(id, 10) : id;
          const packageType = customPackageTypeOptions.find(
            (b) => b.value === numericId
          );
          return packageType?.label; // Return label or undefined if not found
        })
        .filter(Boolean); // Filter out any undefined labels (for IDs not found)

      return selectedLabels.length > 0 ? selectedLabels.join(", ") : "N/A";
    }
  };

  const eventOrderStepStyles = {
    activeColor: "#F9A022",
    finishedColor: "#F9A022",
    waitingColor: "#E5E7EB",
    activeTextColor: "#F9A022",
    finishedTextColor: "#F9A022",
    waitingTextColor: "#9CA3AF",
    connectorColor: "#E5E7EB",
  };
  const getSteps = () => {
    const baseSteps = [
      { title: "Choose Customer", description: "" },
      { title: "Add Order", description: "" },
    ];

    if (packageType === "package") {
      return [
        baseSteps[0],
        { title: "Choose Package", description: "" },
        { title: "Delivery Details", description: "" },
        { title: "Review Order", description: "" },
      ];
    }

    return [
      ...baseSteps,
      { title: "Delivery Details", description: "" },
      { title: "Review Order", description: "" },
    ];
  };
  const handleClose = () => {
    form.resetFields();
    setCurrentStep(0);
    setPackageType("");
    setDiscount("");
    onClose();
  };

  const handleAddPackage = (packageData) => {
    setCateringPackages((prev) => [
      ...prev,
      { ...packageData, id: Date.now() },
    ]);
  };
  // console.log("Packages:", cateringPackages);

  const handleRemovePackage = (id) => {
    setCateringPackages((prev) => prev.filter((pkg) => pkg.id !== id));
  };

  const calculatePackageTotal = (pkg) => {
    return pkg.totalAmount || 0;
  };

  const calculateTotal = () => {
    return cateringPackages.reduce(
      (sum, pkg) => sum + calculatePackageTotal(pkg),
      0
    );
  };

  const calculateReviewData = () => {
    const subtotal =
      packageType === "custom"
        ? parseFloat(form.getFieldValue("totalBudget")) || 0
        : calculateTotal();

    const serviceFeeByLocation = serviceFees?.find(
      (fee) => fee.location_id === parseInt(form.getFieldValue("branch"))
    );
    const serviceFeePercent = serviceFeeByLocation?.service_fee || 0;
    console.log("Service Fee Percent", serviceFeePercent);
    const serviceFeeAmount = (subtotal * serviceFeePercent) / 100;
    let discountAmount = 0;
    let discountText = "0%";

    if (discount) {
      if (discountType === "percentage") {
        const percent = parseFloat(discount);
        discountAmount = (subtotal * percent) / 100;
        discountText = `${percent}%`;
      } else {
        discountAmount = parseFloat(discount) || 0;
        discountText = `₦${discountAmount.toLocaleString()}`;
      }
    }
    return {
      subtotal,
      discount: discountAmount,
      discountText,
      serviceFeeText: `₦${serviceFeeAmount.toLocaleString()}`,
      // total: subtotal - discountAmount + serviceFeeAmount,
      total: subtotal - discountAmount,
    };
  };

  const handleFinish = async () => {
    try {
      // Validate common fields
      const reviewData = calculateReviewData();
      if (packageType === "custom") {
        await form.validateFields();

        const orderPayload = {
          user_id: form.getFieldValue("customer"),
          event_type_id: form.getFieldValue("eventType"),
          event_date: form.getFieldValue("eventDate")?.format("YYYY-MM-DD"),
          event_details: form.getFieldValue("eventDetails") || null,
          phone_number: form.getFieldValue("contactPerson")?.toString() || null,
          expected_guests: form.getFieldValue("guestCount")?.toString() || null,
          pickup_date:
            form.getFieldValue("pickupDate")?.format("YYYY-MM-DD") ||
            form.getFieldValue("eventDate")?.format("YYYY-MM-DD"),

          // Option A: Use event_date as fallback
          delivery_date:
            form.getFieldValue("deliveryDate")?.format("YYYY-MM-DD") ||
            form.getFieldValue("eventDate")?.format("YYYY-MM-DD"),

          pickup_address:
            form.getFieldValue("pickupAddress") ||
            form.getFieldValue("venue") ||
            null,
          role: form.getFieldValue("customerRole") || null,
          is_budget_available: true,
          total_budget: form.getFieldValue("totalBudget"),
          budget_per_person: form.getFieldValue("budgetPerPerson"),
          quote_amount: form.getFieldValue("quoteAmount"),
          food_request: form.getFieldValue("foodRequest") || null,
          quote_url: form.getFieldValue("quoteUrl") || null,
          dietary_preferences: form.getFieldValue("dietaryRequirements") || [],
          beverage_types: form.getFieldValue("drinks") || [],
          package_types: form.getFieldValue("packagingType") || [],
        };
        // console.log("Order Payload:", orderPayload);

        await createEventCustomOrder(orderPayload).unwrap();
        message.success("Catering custom order created successfully!");
        handleClose();
      } else {
        await form.validateFields(["customer", "branch"]);
        const orderPayload = {
          user_id: form.getFieldValue("customer"),
          discount_value: reviewData.discount,
          sub_total: reviewData.total,
          location_id: form.getFieldValue("branch"),
          delivery_address: form.getFieldValue("deliveryLocation") || null,
          delivery_mode: 1,
          is_gift: false,
          gifting_address: form.getFieldValue("giftingAddress") || null,
          delivery_date:
            form.getFieldValue("deliveryDate")?.format("YYYY-MM-DD") || null,
          delivery_instruction: form.getFieldValue("instructions") || null,
          pick_up_time:
            form.getFieldValue("pickUpTime")?.format("HH:mm") || null,
          pick_up_date:
            form.getFieldValue("pickUpDate")?.format("YYYY-MM-DD") || null,
          is_requested_cutlery: true,
          cutlery_instruction:
            form.getFieldValue("cutleryInstructions") || null,
          packages: cateringPackages?.map((pkg) => ({
            package_id: pkg.packageId,
            qty: 1,
            categories: pkg.categories.map((cat) => ({
              category_id: cat.id,
              products: cat.selectedProducts.map((prod) => ({
                product_id: prod.id,
                qty: prod.quantity,
              })),
            })),
          })),
        };

        // console.log("Order Payload:", orderPayload);

        await createEventPackageOrder(orderPayload).unwrap();
        message.success("Catering package order created successfully!");
        handleClose();
      }
    } catch (error) {
      console.error("Error creating order:", error);
      message.error(
        error?.data?.message || "Failed to create bulk order. Please try again."
      );
    }
  };
  const renderStepContent = () => {
    const steps = getSteps();

    if (currentStep === 0) {
      return (
        <Form form={form} layout="vertical">
          <Form.Item
            label="Choose Customer"
            name="customer"
            rules={[{ required: true, message: "Please select a customer" }]}
          >
            <Select
              placeholder="Select Customer"
              size="large"
              loading={customerLoading}
              options={customerOptions}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
          <Form.Item
            label="Package Type"
            name="packageType"
            rules={[
              { required: true, message: "Please select a package type" },
            ]}
          >
            <Select
              placeholder="Select event type"
              size="large"
              options={packageTypeOptions}
              onChange={handlePackageTypeChange}
              value={packageType || undefined}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              className="w-full" // Add some styling if needed
            />
            {/* <select
              className="w-full p-3 border border-gray-300 rounded-lg"
              value={packageType}
              onChange={(e) => setPackageType(e.target.value)}
            >
              <option value="">-- Select package type --</option>
              {packageTypeOptions.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select> */}
          </Form.Item>
        </Form>
      );
    }

    if (packageType === "custom" && currentStep === 1) {
      return (
        <CustomOrderForm
          form={form}
          eventTypeOptions={eventTypeOptions}
          dietaryPreferenceOptions={dietaryPreferenceOptions}
          beverageTypeOptions={beverageTypeOptions}
          customPackageTypeOptions={customPackageTypeOptions}
          serviceTypeOptions={serviceTypeOptions}
          eventTypesLoading={eventTypesLoading}
          dietaryPrefsLoading={dietaryPrefsLoading}
          beverageTypesLoading={beverageTypesLoading}
          packageTypesLoading={packageTypesLoading}
          serviceTypesLoading={serviceTypesLoading}
        />
      );
    }

    if (packageType === "package" && currentStep === 1) {
      return (
        <CateringPackageSelect
          handleRemovePackage={handleRemovePackage}
          discount={discount}
          setDiscount={setDiscount}
          setAddPackageModalOpen={setAddPackageModalOpen}
          packages={cateringPackages}
          calculatePackageTotal={calculatePackageTotal}
          calculateTotal={calculateTotal}
          discountType={discountType}
          setDiscountType={setDeliveryType}
        />
      );
    }

    if (currentStep === 2) {
      return (
        <DeliverySection
          deliveryType={deliveryType}
          setDeliveryType={setDeliveryType}
          form={form}
          locationLoading={locationLoading}
          locationOptions={locationOptions}
        />
      );
    }
    if (currentStep === steps.length - 1) {
      const reviewData = calculateReviewData();

      if (packageType === "custom") {
        return (
          <CustomOrderReviewStep
            form={form}
            reviewData={reviewData}
            getCustomerLabel={getCustomerLabel}
            getEventTypeLabel={getEventTypeLabel}
            getServiceTypeLabel={getServiceTypeLabel}
            getDietaryPreferenceLabel={getDietaryPreferenceLabel}
            getbeverageTypeLabel={getbeverageTypeLabel}
            getpackageTypeLabel={getpackageTypeLabel}
          />
        );
      }

      return (
        <CateringPackageReviewStep
          form={form}
          reviewData={reviewData}
          getCustomerLabel={getCustomerLabel}
          packages={cateringPackages}
          calculatePackageTotal={calculatePackageTotal}
        />
      );
    }

    return null;
  };

  return (
    <>
      <ReusableModal
        open={open}
        onClose={onClose}
        title="Create Event Order"
        subtitle="Kindly fill in the details below to create an event for a customer"
        steps={getSteps()}
        currentStep={currentStep}
        onStepChange={setCurrentStep}
        onFinish={handleFinish}
        isLoading={creatingCustomOrder || creatingPackageOrder}
        form={form}
        stepStyles={eventOrderStepStyles}
        stepsClassName="mb-8 w-[80%] mx-auto"
        position="right"
        slideDirection="right"
        animationDuration={400}
        width={700}
      >
        {renderStepContent()}
      </ReusableModal>

      <AddPackageModal
        open={addPackageModalOpen}
        onClose={() => setAddPackageModalOpen(false)}
        onAddPackage={handleAddPackage}
      />
    </>
  );
};

export default CreateEventOrderModal;
